import React, { useEffect, useState } from 'react';
import "./Ticker.css"
import moment from 'moment';
import Chip from './Chip';
import { getRemainingDays } from './DaysUntilEvent';
import { MdOutlineTextFormat } from 'react-icons/md';
import { deleteTodo, setTodoDeferUntil, getNext2am, getNextSaturday2am, getSameWeekdayNextWeek2am } from './MarkAsDone';
import token from './Token'
import ContextMenu from './MarkAsDoneContextMenu';
import { getNextTickerSlide } from './tickerPagination';
function TickerList({
    data: todoData,
    dataOriginal,
    todoRefreshFlagHandler,
    nItems,
    onlyXDaysFromNow,
    onCycleComplete,
}) {
    const [index, setIndex] = useState(0)
    const [animationState, setAnimationState] = useState(0) // 0 = fade out, 1 = idle, 2 = fade in
    const [listToDisplay, setListToDisplay] = useState([]) // For a scrollable list (length > nItems)
    const [thereIsSomethingToShow, setThereIsSomethingToShow] = useState(false)
    const [lengthToShow, setLengthToShow] = useState(0)
    const [listToShow, setListToShow] = useState([]) // For a short list (length < nItems)
    const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, content: '' });

    useEffect(() => {
        if (window.taskSlideshowTimer) 
        {
            clearInterval(window.taskSlideshowTimer)
            window.taskSlideshowTimer = undefined
        }
        if (lengthToShow > 0 && (lengthToShow > nItems || onCycleComplete)) {
            window.taskSlideshowTimer = setInterval(() => {
                const nextSlide = getNextTickerSlide(index, lengthToShow, nItems)
                if (nextSlide.completedCycle && onCycleComplete) {
                    onCycleComplete()
                } else {
                    setIndex(nextSlide.index)
                }
            }, 5000)
        }
        return () => {
            if (window.taskSlideshowTimer)
            {
                clearInterval(window.taskSlideshowTimer)
                window.taskSlideshowTimer = undefined
            }
        }
    }, [index, lengthToShow, nItems, onCycleComplete])

    useEffect(() => {
        if (todoData && todoData.length > 0) {
            let props_data = []
            if (todoData.length > 0) {
                // Filter out all todos that are not due in the next 45 days
                props_data = todoData.filter((t) => {
                    // Filter all todos starting with * and deferUntil is less than 45 days from now
                    if (t.content.startsWith('*') || moment(t.deferUntil).isAfter(moment().add(45, 'days')))
                    {
                        return false
                    } else {
                        return true
                    }
                })
            }
            if (onlyXDaysFromNow) {
                props_data = props_data.filter(x => {
                    let daysUntil = moment(x.deferUntil).diff(moment(), 'days')
                    return daysUntil <= onlyXDaysFromNow
                })
            }
            // if props_data length is not a multiple of nItems, add some items to the end of the array
            if (props_data.length % nItems !== 0) {
                let nItemsToAdd = nItems - (props_data.length % nItems)
                for (let i = 0; i < nItemsToAdd; i++) {
                    props_data.push({content: ''})
                }
            }
            if (props_data.length > 0) {
                setThereIsSomethingToShow(true)
                setLengthToShow(props_data.length)
                setListToShow(props_data)
            } else {
                setThereIsSomethingToShow(false)
                setListToShow([])
                setLengthToShow(0)
            }
            // Fade out the current text by setting animationState to 0
            setAnimationState(0)
            // Wait for the fade out animation to finish
            setTimeout(() => {
                // Get nItems items from the data array
                let list = []
                for (let i = 0; i < nItems; i++) {
                    list.push(props_data[(index + i) % props_data.length])
                }
                // Set the list to display
                setListToDisplay(list)
                // Fade in the new text by setting animationState to 2
                setAnimationState(2)
            }
            , 500)
        } else {
            setThereIsSomethingToShow(false)
            setListToShow([])
            setLengthToShow(0)
        }
    }, [index, todoData, onlyXDaysFromNow, nItems])

    const deleteTodoCallback = async (content) => {
        await deleteTodo(dataOriginal, token, content);
        if (todoRefreshFlagHandler) {
            todoRefreshFlagHandler() // force a refresh of the todos
        }
    }

    const deferTodoCallback = async (content, deferUntilISO) => {
        await setTodoDeferUntil(dataOriginal, token, content, deferUntilISO);
        if (todoRefreshFlagHandler) {
            todoRefreshFlagHandler() // force a refresh of the todos
        }
    }

    const handleContextMenu = (e, content) => {
        e.preventDefault();
        setContextMenu({
            visible: true,
            x: e.pageX,
            y: e.pageY,
            content: content
        });
    };

    return(
        <>
            {thereIsSomethingToShow && lengthToShow > nItems && (<div className={`${animationState === 0 ? 'TickerOut' : (animationState === 2 ? 'TickerIn' : '')}`}>
                <div style={{listStyle: 'none', padding: 0}}>
                    {listToDisplay.map((item, i) => {
                        if (item.content === '') {
                            // This is a dummy item, so don't show it
                            return (<div key={i} className='chip-blank'></div>)
                        }
                        let daysUntil = getRemainingDays(item.deferUntil)
                        if (daysUntil < 2)
                        {
                            return (<div key={i} onContextMenu={(e) => handleContextMenu(e, item.content)}><Chip text={daysUntil.toFixed(1)} color='red'></Chip><span style={{paddingLeft: 6}}></span>{item.content.replace(/\*/g, '')}{item.notes ? <MdOutlineTextFormat></MdOutlineTextFormat> : <></>}</div>)
                        } else if (daysUntil < 7) {
                            return (<div key={i} onContextMenu={(e) => handleContextMenu(e, item.content)}><Chip text={daysUntil.toFixed(1)} color='yellow'></Chip><span style={{paddingLeft: 6}}></span>{item.content.replace(/\*/g, '')}{item.notes ? <MdOutlineTextFormat></MdOutlineTextFormat> : <></>}</div>)
                        } else {
                            return (<div key={i} onContextMenu={(e) => handleContextMenu(e, item.content)}><Chip text={daysUntil.toFixed(1)} color='green'></Chip><span style={{paddingLeft: 6}}></span>{item.content.replace(/\*/g, '')}{item.notes ? <MdOutlineTextFormat></MdOutlineTextFormat> : <></>}</div>)
                        }
                    })}
                </div>
            </div>)}
            {thereIsSomethingToShow && lengthToShow <= nItems && (<div className={`${animationState === 0 ? 'TickerOut' : (animationState === 2 ? 'TickerIn' : '')}`}>
                <div>
                    {listToShow.map((item, i) => {
                        if (item.content === '') {
                            // This is a dummy item, so don't show it
                            return (<div key={i} className='chip-blank'></div>)
                        }
                        let daysUntil = getRemainingDays(item.deferUntil)
                        if (daysUntil < 2)
                        {
                            return (<div key={i} onContextMenu={(e) => handleContextMenu(e, item.content)}><Chip text={daysUntil.toFixed(1)} color='red'></Chip><span style={{paddingLeft: 6}}></span>{item.content.replace(/\*/g, '')}{item.notes ? <MdOutlineTextFormat></MdOutlineTextFormat> : <></>}</div>)
                        } else if (daysUntil < 7) {
                            return (<div key={i} onContextMenu={(e) => handleContextMenu(e, item.content)}><Chip text={daysUntil.toFixed(1)} color='yellow'></Chip><span style={{paddingLeft: 6}}></span>{item.content.replace(/\*/g, '')}{item.notes ? <MdOutlineTextFormat></MdOutlineTextFormat> : <></>}</div>)
                        } else {
                            return (<div key={i} onContextMenu={(e) => handleContextMenu(e, item.content)}><Chip text={daysUntil.toFixed(1)} color='green'></Chip><span style={{paddingLeft: 6}}></span>{item.content.replace(/\*/g, '')}{item.notes ? <MdOutlineTextFormat></MdOutlineTextFormat> : <></>}</div>)
                        }
                        // return (<li key={i}>{item.content.replace(/\*/g, '') + ' (in ' + daysUntilTodo + ' days)'}</li>)
                    })}
                </div>
            </div>)}
            <ContextMenu
                visible={contextMenu.visible}
                x={contextMenu.x}
                y={contextMenu.y}
                onClose={() => setContextMenu(prev => ({ ...prev, visible: false }))}
                menuItems={[
                    {
                        label: 'Delete',
                        onClick: async (e) => {
                            if (contextMenu.content) {
                                await deleteTodoCallback(contextMenu.content);
                            }
                            e.preventDefault();
                        }
                    },
                    {
                        label: 'Defer Tomorrow',
                        onClick: async (e) => {
                            if (contextMenu.content) {
                                await deferTodoCallback(contextMenu.content, getNext2am().toISOString());
                            }
                            e.preventDefault();
                        }
                    },
                    {
                        label: 'Defer WE',
                        onClick: async (e) => {
                            if (contextMenu.content) {
                                await deferTodoCallback(contextMenu.content, getNextSaturday2am().toISOString());
                            }
                            e.preventDefault();
                        }
                    },
                    {
                        label: 'Defer next week',
                        onClick: async (e) => {
                            if (contextMenu.content) {
                                await deferTodoCallback(contextMenu.content, getSameWeekdayNextWeek2am().toISOString());
                            }
                            e.preventDefault();
                        }
                    }
                ]}
            />
        </>
    )
}

export default React.memo(TickerList)
